import React, { useEffect, useState, useContext } from "react";
import Pagination from "react-js-pagination";
import customizationsV2Service from "../../services/api/customizations-v2-service";
import projectsService from "../../services/api/projects-service";
import { useHistory, Link } from "react-router-dom";
import Moment from "react-moment";
import Select from "react-select";
import Switch from "react-bootstrap-switch";
import ReactBSAlert from "react-bootstrap-sweetalert";
import UserContext from "../../UserContext";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    Spinner,
    Table,
    Container,
    Row,
    Col,
} from "reactstrap";

const AppConfigV2Version = (props) => {
    const projectId = new URLSearchParams(props.location.search).get('projectid');
    const platform = new URLSearchParams(props.location.search).get('platform');
    const context = useContext(UserContext);

    const [configVersions, setConfigVersions] = useState([]);
    const [projectName, setProjectName] = useState("");
    const [componentRendered, setComponentRendered] = useState(false);
    const [reloadComponent, setReloadComponent] = useState(0);
    const [showPopup, setShowPopup] = useState({ alert: null }); // prettier-ignore
    const [formdetails, setFormDetails] = useState({ version: '', name: '', projectId: projectId, templateId: '', platform: platform, engine_version: '' });
    const history = useHistory();

    const [showCreateConfig, setShowCreateConfig] = useState(false);
    const [versionOptions, setVersionOptions] = useState([]);
    const [hideButton, setHideButton] = useState(false);
    const [createLoader, setCreateLoader] = useState(false);
    const [versionState, setVersionState] = useState("");
    const [versionError, setVersionError] = useState("");
    const [isDraftConfigPresent, setIsDraftConfigPresent] = useState(false);
    const [configCount, setConfigCount] = useState(0);
    const [existingConfigs, setExistingConfigs] = useState(false);
    const [nameState, setNameState] = useState("");
    const [nameError, setNameError] = useState("");
    const [v2AppTemplates, setV2AppTemplates] = useState([]);
    const [templateIdState, setTemplateIdState] = useState("");
    const [templateIdError, setTemplateIdError] = useState("");
    const [engineVersionState, setEngineVersionState] = useState("");
    const [existingEngineVersions, setExistingEngineVersions] = useState([]);
    const [engineVersionError, setEngineVersionError] = useState("");

    useEffect(() => {
        let isMounted = true;
        (async () => {
            try {
                const projectDetailsResponse = await projectsService.getProjectDetails(projectId);
                if (isMounted && projectDetailsResponse.status && projectDetailsResponse.data) {
                    setProjectName(projectDetailsResponse.data.name);
                }

                const versionsResponse = await customizationsV2Service.getAppV2ConfigVersions(projectId, platform);
                if (isMounted) {
                    if (versionsResponse.status && versionsResponse.data) {
                        setConfigVersions(versionsResponse.data.versions);
                        let allVersion = versionsResponse.data.versions;
                        let versionArray = [];
                        let configs = [];
                        let engineVersions = [];
                        let publishedConfigCount = 0;
                        if (allVersion.length) {
                            allVersion.forEach(function (versionDetails) {
                                configs.push(versionDetails.name);
                                if (versionDetails.engine_version) {
                                    engineVersions.push(versionDetails.engine_version);
                                }
                                if (versionDetails.status && versionDetails.is_published) {
                                    versionArray.push({ value: versionDetails.version, label: versionDetails.name });
                                    publishedConfigCount++;
                                }
                            });
                            setExistingConfigs(configs);
                            setExistingEngineVersions(engineVersions);
                            setConfigCount(publishedConfigCount);
                            setVersionOptions(versionArray);
                        } else {
                            setVersionOptions([]);
                        }
                        setIsDraftConfigPresent(versionsResponse.data.isDraftConfigPresent);

                        if (allVersion.length === 0) {
                            try {
                                const templatesResponse = await customizationsV2Service.getV2AppTemplatesList(platform);
                                if (isMounted && templatesResponse.status && templatesResponse.data) {
                                    setV2AppTemplates(templatesResponse.data.map(t => ({ value: t.id, label: t.name })));
                                } else if (isMounted) {
                                    console.error("Failed to fetch V2 app templates:", templatesResponse?.error);
                                    setV2AppTemplates([]);
                                }
                            } catch (templateError) {
                                if (isMounted) {
                                    console.error("Error fetching V2 app templates:", templateError);
                                    setV2AppTemplates([]);
                                }
                            }
                        } else {
                            if (isMounted) setV2AppTemplates([]);
                        }
                    } else {
                        console.error("Failed to fetch app config versions:", versionsResponse.error);
                        if (isMounted) {
                            setVersionOptions([]);
                            setV2AppTemplates([]);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
                if (isMounted) {
                    setVersionOptions([]);
                    setV2AppTemplates([]);
                }
            } finally {
                if (isMounted) {
                    setComponentRendered(true);
                }
            }
        })();
        return () => {
            isMounted = false;
        };
    }, [reloadComponent, projectId, platform]);

    const handleChange = (event) => {
        setFormDetails({
            ...formdetails,
            [event.target.id]: event.target.value,
        });
        if (event.target.id === "name") {
            setNameState("has-success");
            setNameError("");
        }
        if (event.target.id === "engine_version") {
            setEngineVersionState("has-success");
            setEngineVersionError("");
        }
    };

    const handleVersionChange = (selectedOption) => {
        setFormDetails({
            ...formdetails,
            version: selectedOption ? selectedOption.value : '',
            templateId: '',
        });
        setVersionError('');
        setVersionState(selectedOption ? 'has-success' : '');
        if (selectedOption) {
            setTemplateIdError('');
            setTemplateIdState('');
        }
    };

    const handleTemplateChange = (selectedOption) => {
        setFormDetails({
            ...formdetails,
            templateId: selectedOption ? selectedOption.value : '',
            version: '',
        });
        setTemplateIdError('');
        setTemplateIdState(selectedOption ? 'has-success' : '');
        if (selectedOption) {
            setVersionError('');
            setVersionState('');
        }
    };

      const handlePublishConfigSwitch = async (projectId, version, platform, enabled) => {
    
            if (enabled) {
                const response = await customizationsV2Service.publishAppConfig(projectId, version, platform);
                if(!response.status && response.error.errorCode === 403){
                    setShowPopup({
                        alert:null
                    });
                    context.setIsAuthorized(context);
                }
                else if (response.status) {
                    setShowPopup({
                        alert: (
                            <ReactBSAlert
                                success
                                style={{ display: "block", marginTop: "-100px" }}
                                title="Config Published!"
                                onConfirm={() => hideAlert()}
                                onCancel={() => hideAlert()}
                                confirmBtnBsStyle="info"
                                btnSize=""
                            >
                                Config Published successfully.
                            </ReactBSAlert>
                        ),
                    });
        
                    setTimeout(() => {
                        hideAlert();
                    }, 3000);
    
    
                    setReloadComponent(Math.random());
                }else
                {
                    setShowPopup({
                        alert: (
                            <ReactBSAlert
                                danger
                                style={{ display: "block", marginTop: "-100px" }}
                                title="Config could not Publish!"
                                onConfirm={() => hideAlert()}
                                onCancel={() => hideAlert()}
                                confirmBtnBsStyle="info"
                                btnSize=""
                            >
                                Config could not Publish.
                            </ReactBSAlert>
                        ),
                    });
        
                    setTimeout(() => {
                        hideAlert();
                    }, 3000);
                    setReloadComponent(Math.random());
                }
            }else{
                setReloadComponent(Math.random());
    
            }
        };
     const confirmationPopup = (projectId, version, platform, enabled) => {
            setShowPopup({
                alert: (
                    <ReactBSAlert
                        success
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Are you sure want to publish this Config version ?"
                        onConfirm={() => {
                            handlePublishConfigSwitch(projectId, version, platform, enabled);
                            hideAlert();
                        }}
                        onCancel={() => {
                            hideAlert();
                        }}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        confirmBtnText="Yes, Publish it!"
                        cancelBtnText="Cancel"
                        showCancel
                        btnSize=""
                    >
                        You want to Publish Config!
                    </ReactBSAlert>
                ),
            });
        };
    const onConfirm = async () => {
        let isValid = true;
        if (formdetails.name === "") {
            setNameState('has-danger');
            setNameError('version name is required.');
            isValid = false;
        } else {
            if (existingConfigs) {
                const duplicateName = existingConfigs.some(existingConfigName => formdetails.name.trim() === existingConfigName.trim());
                if (duplicateName) {
                    setNameState("has-danger");
                    setNameError("You have already created config with this name .");
                    isValid = false;
                }
            }
        }

        if (formdetails.engine_version === "") {
            setEngineVersionState('has-danger');
            setEngineVersionError('Engine version is required.');
            isValid = false;
        } else if (existingEngineVersions.some(v => v === formdetails.engine_version.trim())) {
            setEngineVersionState('has-danger');
            setEngineVersionError('An app config with this engine version already exists.');
            isValid = false;
        }

        if (versionOptions.length > 0 && !formdetails.version) {
            setVersionError('This field is required.');
            setVersionState('has-danger');
            isValid = false;
        }

        if (versionOptions.length === 0 && v2AppTemplates.length > 0) {
            if (!formdetails.templateId) {
                setTemplateIdError('Please select a template to create the first configuration.');
                setTemplateIdState('has-danger');
                isValid = false;
            }
        }

        if (!isValid) return;

        setHideButton(true);
        setCreateLoader(true);
        const response = await customizationsV2Service.createAppConfig(formdetails);
        setShowCreateConfig(false);
        setCreateLoader(false);
        setHideButton(false);

        if (!response.status && response.error.errorCode === 403) {
            setShowPopup({ alert: null });
            context.setIsAuthorized(context);
        } else if (response.status && response.data) {
            setShowPopup({
                alert: (
                    <ReactBSAlert
                        success
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Created!"
                        onConfirm={() => hideAlert()}
                        onCancel={() => hideAlert()}
                        confirmBtnBsStyle="info"
                        showConfirm
                        btnSize=""
                    >
                        Config has been created successfully.
                    </ReactBSAlert>
                ),
            });
        } else {
            setShowPopup({
                alert: (
                    <ReactBSAlert
                        danger
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Please try again!"
                        onConfirm={() => hideAlert()}
                        onCancel={() => hideAlert()}
                        confirmBtnBsStyle="info"
                        btnSize=""
                    >
                        Config could not be created. Please try again.
                    </ReactBSAlert>
                ),
            });
        }

        setTimeout(() => {
            hideAlert();
            setReloadComponent(prev => prev + 1);
        }, 3000);
    };

    const onCancel = () => {
        setShowCreateConfig(false);
        setFormDetails({ version: '', name: '', projectId: projectId, templateId: '', platform: platform, engine_version: '' });
        setNameState('');
        setNameError('');
        setVersionState('');
        setVersionError('');
        setTemplateIdState('');
        setTemplateIdError('');
        setEngineVersionState('');
        setEngineVersionError('');
    };

    const hideAlert = () => setShowPopup({ alert: null });

    return (
        <div className="content">
            {showPopup.alert}
            {showCreateConfig ? (
                <ReactBSAlert
                    title={"Create New Version of Config"}
                    type={"controlled"}
                    style={{ position: "relative", minHeight: "450px", width: "50%" }}
                    closeOnClickOutside={false}
                    showConfirm={false}
                    showCancel={false}
                    reverseButtons={true}
                >
                    <Card>
                        <CardHeader />
                        <CardBody>
                            <FormGroup className={nameState}>
                                <Input type="text" onChange={handleChange} name="name" id="name" placeholder="Enter version name" />
                                {nameState === "has-danger" && <label className="error">{nameError}</label>}
                            </FormGroup>

                            <FormGroup className={engineVersionState}>
                                <Input type="text" onChange={handleChange} name="engine_version" id="engine_version" placeholder="Enter engine version" />
                                {engineVersionState === "has-danger" && <label className="error">{engineVersionError}</label>}
                            </FormGroup>

                            {versionOptions.length === 0 && v2AppTemplates.length > 0 && (
                                <FormGroup className={templateIdState}>
                                    <Label>Select a template to start with</Label>
                                    <Select
                                        className={"react-select"}
                                        classNamePrefix="react-select"
                                        placeholder="Select a template..."
                                        name="templateId"
                                        id="templateId"
                                        options={v2AppTemplates}
                                        value={formdetails.templateId ? v2AppTemplates.find(t => t.value === formdetails.templateId) : null}
                                        onChange={handleTemplateChange}
                                    />
                                    {templateIdState === "has-danger" && <label className="error">{templateIdError}</label>}
                                </FormGroup>
                            )}

                            {versionOptions.length > 0 && (
                                <FormGroup className={versionState}>
                                    <Label>Copy from existing version</Label>
                                    <Select
                                        className={"react-select"}
                                        classNamePrefix="react-select"
                                        placeholder="Select version to copy from..."
                                        name="version"
                                        id="version"
                                        options={versionOptions}
                                        value={formdetails.version ? versionOptions.find(v => v.value === formdetails.version) : null}
                                        onChange={handleVersionChange}
                                        isClearable
                                    />
                                    {versionState === "has-danger" && <label className="error">{versionError}</label>}
                                </FormGroup>
                            )}

                            <br />
                            {createLoader && <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>}
                            {!hideButton && (
                                <>
                                    <Button style={{ backgroundColor: "blue" }} className="btnB" type="button" onClick={onConfirm}>Create</Button>
                                    <Button className="btnBlk" type="button" onClick={onCancel}>Cancel</Button>
                                </>
                            )}
                        </CardBody>
                    </Card>
                </ReactBSAlert>
            ) : null}

            <Container>
                <Row>
                    <Col className="ml-auto mr-auto" md="12">
                        <Card className="card-signup text-center">
                            <CardHeader>
                                <CardTitle tag="h4">Config Version of V2 App - {projectName}</CardTitle>
                                {!isDraftConfigPresent && (
                                    <Button
                                        style={{ float: "right", marginTop: "-50px" }}
                                        className="btn-round"
                                        color="btn-ble"
                                        size="sm"
                                        type="button"
                                        onClick={() => {
                                            setFormDetails({ version: '', name: '', projectId: projectId, templateId: '', platform: platform, engine_version: '' });
                                            setNameState('');
                                            setNameError('');
                                            setVersionState('');
                                            setVersionError('');
                                            setTemplateIdState('');
                                            setTemplateIdError('');
                                            setEngineVersionState('');
                                            setEngineVersionError('');
                                            setShowCreateConfig(true);
                                        }}
                                    >
                                        Create New Config
                                    </Button>
                                )}
                            </CardHeader>
                            <CardBody>
                                <Table responsive>
                                    <thead className="text-primary">
                                        <tr>
                                            <th className="text-left">#</th>
                                            <th className="text-left">Name</th>
                                            <th className="text-left">Created At</th>
                                            <th className="text-left">Updated At</th>
                                            <th className="text-left">Modified By</th>
                                            <th className="text-left">Engine Version</th>
                                            <th className="text-left">is_published</th>
                                            <th className="text-left">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {configVersions.length === 0 ? (
                                            !componentRendered ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        <Spinner animation="border" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </Spinner>
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        <CardTitle tag="h4">No Records Found</CardTitle>
                                                    </td>
                                                </tr>
                                            )
                                        ) : (
                                            configVersions.map((configVersion, index) => (
                                                <tr key={index} className={!configVersion.status ? "table-danger" : ""}>
                                                    <td className="text-left">{index + 1}</td>
                                                    <td className="text-left">{configVersion.name || ""}</td>
                                                    <td className="text-left">
                                                        <Moment format="DD MMM YYYY hh:mm:ss a">{configVersion.createdAt}</Moment>
                                                    </td>
                                                    <td className="text-left">
                                                        <Moment format="DD MMM YYYY hh:mm:ss a">{configVersion.updatedAt}</Moment>
                                                    </td>
                                                    <td className="text-left">{configVersion.modified_by || "System"}</td>
                                                    <td className="text-left">{configVersion.engine_version || ""}</td>
                                                    <td className="text-left">
                                                        <Switch
                                                            name="is_default"
                                                            offColor="success"
                                                            offText={<i className="nc-icon nc-simple-remove" />}
                                                            onColor="success"
                                                            disabled={!!configVersion.is_published}
                                                            onText={<i className="nc-icon nc-check-2" />}
                                                            value={!!configVersion.is_published}
                                                            onChange={(value, enabled) => {
                                                                confirmationPopup(projectId, configVersion.version, platform, enabled)
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="text-left">
                                                        <Link to={{ pathname: '/config/v2/appcustomizations', search: `?projectid=${projectId}&version=${configVersion.version}&platform=${platform}` }}>
                                                            <Button className="btn-round btn-primary" color="primary" size="sm" type="button">
                                                                Edit
                                                            </Button>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AppConfigV2Version;
